import api from '@/api/axios';
import { ENDPOINTS } from '@/api/endpoints';

/**
 * AI API service
 */

export interface AISearchFilter {
  status?: string[];
  assignee?: string[];
  priority?: string[];
  issueType?: string[];
  dateRange?: { start?: string; end?: string };
  labels?: string[];
  keyword?: string;
}

export interface AISearchResult {
  filter: AISearchFilter;
  originalQuery: string;
}

export interface AIProjectSummary {
  summary: string;
  provider: string;
}

export interface AISmartIssue {
  title: string;
  description: string;
  issueType: string;
  priority: string;
  labels: string[];
}

export const searchWithAI = async (
  projectId: string,
  query: string
): Promise<AISearchResult> => {
  const response = await api.post<AISearchResult>(
    ENDPOINTS.AI.SEARCH(projectId),
    { query }
  );
  return response.data;
};

export const summarizeProject = async (
  projectId: string
): Promise<AIProjectSummary> => {
  const response = await api.post<AIProjectSummary>(
    ENDPOINTS.AI.SUMMARIZE(projectId)
  );
  return response.data;
};

export const createSmartIssue = async (
  projectId: string,
  description: string
): Promise<AISmartIssue> => {
  const response = await api.post<AISmartIssue>(
    ENDPOINTS.AI.CREATE_ISSUE(projectId),
    { description }
  );
  return response.data;
};

export const aiApi = {
  searchWithAI,
  summarizeProject,
  createSmartIssue,
};

export default aiApi;
